import { ArrowRight } from "lucide-react";

const PARTNERS = [
  { code: "RU.001", title: "Joining the Community", body: "Operators-in-the-making, career switchers, and seasoned veterans. All welcome." },
  { code: "RU.002", title: "Collaboration", body: "Universities, technical institutes, and labs co-designing programs and pathways." },
  { code: "RU.003", title: "Partnership", body: "Hyperscalers, colos, OEMs, energy and cooling partners shaping the pipeline together." },
  { code: "RU.004", title: "Sponsorship", body: "Brand alignment with the operators, engineers, and builders defining the AI-era stack." },
  { code: "RU.005", title: "DCYB Certified Partner", body: "The companies building the future, standing with the people who will run it.", href: "#certified-partner" },
  { code: "RU.006", title: "Events", body: "IRL convenings, technical deep-dives, and operator-grade programming." },
  { code: "RU.007", title: "Training & Certification", body: "Cohorts and credentials calibrated to actual site, MEP, and ops realities." },
  { code: "RU.008", title: "Hiring Talent", body: "Direct access to a vetted network of operators, technicians, controls and ops leaders." },
  { code: "RU.009", title: "Funding", body: "Venture, growth, and strategic capital backing the talent layer of digital infrastructure." },
];

export default function Audience() {
  return (
    <section
      id="audience"
      data-testid="audience-section"
      className="border-b hairline bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-32">
        <div className="grid grid-cols-12 gap-y-12 gap-x-6 mb-16">
          <div className="col-span-12 lg:col-span-5">
            <div data-testid="audience-section-label" className="font-mono-label text-[11px] text-[#0F1117] mb-6">
              / Who we partner with
            </div>
            <h2 className="font-display text-3xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight font-extrabold text-[#0F1117] text-balance">
              Work with us.
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-6 lg:col-start-7">
            <p className="text-base sm:text-lg text-[#3D4049] leading-relaxed max-w-xl">
              {"Whether you're investing in the future, hiring talent, hosting the next generation, or stepping into the industry — there's a way to work together. Pick what fits and we'll build alongside you."}
            </p>
          </div>
        </div>

        <div className="border-t hairline">
          {PARTNERS.map((p) => (
            <a
              key={p.code}
              href={p.href || "/get-involved"}
              data-testid={`partner-row-${p.code}`}
              className="group grid grid-cols-12 items-start gap-x-0 sm:gap-x-6 border-b hairline py-8 md:py-10 hover:bg-[#F4F5F7] transition-colors px-1"
            >
              <div className="col-span-3 sm:col-span-1">
                <span className="font-mono-label text-[11px] text-[#71747B] group-hover:text-[#0F1117] transition-colors">
                  {p.code}
                </span>
              </div>
              <div className="col-span-9 sm:col-span-4">
                <h3 className="font-display text-2xl sm:text-lg md:text-xl lg:text-[1.6rem] xl:text-3xl font-bold text-[#0F1117] tracking-tight hyphens-auto break-words group-hover:text-chrome transition-colors">
                  {p.title}
                </h3>
              </div>
              <div className="col-span-12 sm:col-span-6 mt-3 sm:mt-0">
                <p className="text-[15px] text-[#52555B] leading-relaxed">
                  {p.body}
                </p>
              </div>
              <div className="hidden sm:flex col-span-1 justify-end">
                <ArrowRight
                  size={20}
                  className="text-[#71747B] -translate-x-2 opacity-0 group-hover:opacity-100 group-hover:translate-x-0 group-hover:text-[#0F1117] transition-all"
                />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
